document.addEventListener("DOMContentLoaded", function () {

let page = 2;
let loading = false;

function loadMoreProducts() {

if (loading) return;

const pagination = document.querySelector('#AjaxinatePagination');

if (!pagination) return;

const rect = pagination.getBoundingClientRect();

if (rect.top <= window.innerHeight + 300) {

loading = true;

let url = window.location.pathname + '?page=' + page;

fetch(url)
.then(function(response){
return response.text();
})
.then(function(html){

const parser = new DOMParser();
const doc = parser.parseFromString(html, 'text/html');

const newProducts =
doc.querySelector('#AjaxinateContainer');

if (!newProducts) return;

document
.querySelector('#AjaxinateContainer')
.insertAdjacentHTML('beforeend', newProducts.innerHTML);

page++;
loading = false;

});

}

}

window.addEventListener('scroll', loadMoreProducts);

});